import React, { useEffect, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import { ZIndex } from '@rover/constants/src/styles/ZIndex';
import Grow from '@rover/icons/svg/grow.svg';
import Shrink from '@rover/icons/svg/shrink.svg';
import { Button, Flex } from '@rover/kibble/core';

import ZoomControls from './ZoomControls';

type Props = {
  isExpanded: boolean;
  mapHasMoved: boolean;
  onSearchThisAreaPress: () => void;
  onMapExpanderClick: () => void;
  isSearchLoading?: boolean;
};

export default function MapControlsV2({
  isExpanded,
  mapHasMoved,
  onSearchThisAreaPress,
  onMapExpanderClick,
  isSearchLoading,
}: Props): JSX.Element {
  const [shouldShowSearchThisArea, setShouldShowSearchThisArea] = useState(false);

  useEffect(() => {
    // We want to continue to show the button while the search results are loading
    if (isSearchLoading || mapHasMoved) {
      setShouldShowSearchThisArea(true);
    } else {
      setShouldShowSearchThisArea(false);
    }
  }, [isSearchLoading, mapHasMoved]);

  return (
    <Flex
      position="absolute"
      justifyContent="space-between"
      alignItems="flex-start"
      zIndex={ZIndex.ONE.toString()}
      top="3x"
      left="5x"
      right="5x"
    >
      <Button
        onPress={onMapExpanderClick}
        circular
        size="small"
        icon={isExpanded ? Shrink : Grow}
        aria-expanded={isExpanded}
        aria-label={isExpanded ? t`Shrink map` : t`Enlarge map`}
        alignSelf="flex-start"
      />
      {shouldShowSearchThisArea && (
        <Button
          size="small"
          contrast
          onPress={onSearchThisAreaPress}
          iconAlignment="right"
          loading={isSearchLoading}
          alignSelf="flex-start"
        >
          <Trans>Search this area</Trans>
        </Button>
      )}
      <ZoomControls />
    </Flex>
  );
}
